// @ts-ignore

import { Link } from "react-router-dom";
import { ArrowDownUp } from "lucide-react";

interface ColumnsProps {
  RequestCarringLoad: (data: any) => void;
  cancelRequest: (data: any) => void;
  columnName: (data: any) => void;
  userinfo: any;
}

const ReadyLoadColumnData = ({
  RequestCarringLoad,
  cancelRequest,
  columnName,
  userinfo,
}: ColumnsProps) => {
  
  
  return [
    {
      header: () => (
        <div
          className="flex items-center gap-1"
          onClick={() => columnName("weight")}
        >
          <span onClick={() => columnName("loading_date")}>
            {" "}
            تاریخ بار گیری
          </span>

          <ArrowDownUp className="text-blue-800" size={16} />
        </div>
      ),

      accessorKey: "loading_date",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },
    {
      header: "درخواست",
      enableColumnFilter: false,
      enableSorting: true,
      cell: (cell: any) => {
        const carried = cell.row.original.carried;
        return (
          <div className="flex gap-3">
            <Link
              to="#!"
              data-modal-target="addEmployeeModal"
              className={`flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md ${
                carried
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed dark:bg-zink-700 dark:text-zink-400"
                  : "bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
              }`}
              onClick={(e) => {
                if (carried) {
                  e.preventDefault();
                  return;
                }
                const data = cell.row.original;
                RequestCarringLoad(data);
              }}
              style={carried ? { pointerEvents: "none" } : {}}
            >
              <span
                className={`rounded p-1 mx-auto w-40 ml-3 ${
                  carried
                    ? "bg-gray-400 text-white cursor-not-allowed z-50"
                    : "bg-green-600 text-white"
                }`}
              >
                {carried ? "ثبت شده توسط راننده" : "درخواست حمل بار"}
              </span>
            </Link>
          </div>
        );
      },
    },
    {
      header: "روستا",
      accessorKey: "village_name",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all mx-auto duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },
    {
      header: () => (
        <div className="flex items-center gap-1">
          <span onClick={() => columnName("loading_date")}> وزن بار </span>
          <ArrowDownUp className="text-blue-800" size={16} />
        </div>
      ),
      accessorKey: "weight",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },
    {
      header: "نام کشاورز",
      accessorKey: "farmer_name",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },
    {
      header: "شماره همراه کشاورز",
      accessorKey: "farmer_phone",
      enableColumnFilter: false,
      cell: (cell: any) => {
        const driver_id = cell.row.original.driver_id ? false : true;
        const isCheckDriver = userinfo?.id === cell?.row?.original?.driver_id ? true : false;
        return (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {driver_id
              ? cell.getValue()
              : isCheckDriver
              ? cell.getValue()
              : "***-***-****"}
          </Link>
        );
      },
    },
    {
      header: "مبدا",
      accessorKey: "origin_city",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },
    {
      header: "مقصد",
      accessorKey: "destination_city",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },

    {
      header: "کرایه حمل تن",
      accessorKey: "carriage_fee_per_ton",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()?.toLocaleString("fa-IR")}
        </Link>
      ),
    },
    ,
    {
      header: "لغو",
      enableColumnFilter: false,
      enableSorting: true,
      cell: (cell: any) => {
        const driver_id = cell.row.original.driver_id ? false : true;
        return (
          <div className="flex gap-3">
            <Link
              to="#!"
              data-modal-target="addEmployeeModal"
              className={`flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md ${
                driver_id
                  ? "bg-red-300 text-gray-500 cursor-not-allowed dark:bg-zink-700 dark:text-zink-400"
                  : "bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
              }`}
              onClick={(e) => {
                if (driver_id) {
                  e.preventDefault();
                  return;
                }
                const data = cell.row.original;
                cancelRequest(data);
              }}
              style={driver_id ? { pointerEvents: "none" } : {}}
            >
              <span
                className={`rounded p-1 mx-auto w-40 ml-3 ${
                  driver_id
                    ? "bg-gray-400 text-white cursor-not-allowed"
                    : "bg-green-600 text-white"
                }`}
              >
                {driver_id ? "لغو حمل" : "لغو حمل"}
              </span>
            </Link>
          </div>
        );
      },
    },
    {
      header: "سال زراعی",
      accessorKey: "crop_year_name",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()?.toLocaleString("fa-IR")}
        </Link>
      ),
    },
  ];
};

export default ReadyLoadColumnData;
